var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewsflashesCircleArrowBlue = function SvgNewsflashesCircleArrowBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 26,
    height: 26,
    rx: 13,
    transform: "rotate(-180 26 26)",
    fill: "#011D6B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.785 18.871.688.726 1.376-1.451-.688-.726-4.273-4.508 4.105-4.332.688-.725-1.376-1.452-.688.726L9.84 12.17l-.688.726.182.192-.015.015.688.726 4.78 5.041Z",
    fill: "#fff"
  })));
};
export default SvgNewsflashesCircleArrowBlue;